/**
 * @fileoverview Module for `src/Beacon.js`.
 */

import { message } from './lib/deprecated_i18n';
import deprecatedConfig from './lib/deprecatedConfig';
import axios from 'axios';

/**
 * HelpScout Beacon helpers for in-app support widgets.
 */

/**
 * Destroys the active Beacon instance.
 */
export function destroyBeacon() {
  window.Beacon('destroy');
}

/**
 * Initializes Beacon then immediately opens it.
 *
 * @param {Object} [initArgs={}] - Beacon initialization options.
 */
export function initAndOpenBeacon(initArgs = {}) {
  initBeacon(initArgs);
  openBeacon();
}

/**
 * Initializes Beacon and optionally identifies the authenticated user.
 *
 * @param {Object} [params={}]
 * @param {string} [params.type='help'] - Beacon id suffix (e.g. `help`).
 * @param {Object} params.auth - Auth API object.
 * @param {Object} [params.beaconArgs={}] - Optional Beacon config/prefill values.
 * @returns {Promise<void>}
 */
export async function initBeacon({ type = 'help', auth, beaconArgs = {}} = {}) {
  // looking for a key like 'helpBeaconId'
  const beaconId = await deprecatedConfig.get(`${ type }BeaconId`);
  window.Beacon('init', beaconId);
  if (auth.isAuthenticated()) {
    const accessToken = await auth.getAccessToken();
    const result = await axios.get(`${ process.env.REACT_APP_API_URL }/v1/users/self/beaconInfo`, {
      headers: {
        Authorization: 'Bearer '.concat(accessToken),
      },
      params: {
        type,
      },
    });
    window.Beacon('identify', result.data);
  }
  const beaconConfig = beaconArgs.config || {};
  window.Beacon('prefill', beaconArgs.prefill || { subject: '' });
  window.Beacon('config', {
    ...beaconConfig,
    color: '#00e6ff',
    labels: {
      noTimeToWaitAround: message('beacon.response.time'),
      responseTime: message('beacon.response.time'),
      messageConfirmationText: message('beacon.response.time'),
    },
  });
}

/**
 * Opens the Beacon UI.
 */
export function openBeacon() {
  window.Beacon('open');
}

/**
 * Navigates Beacon to a specific internal location.
 *
 * @param {string} location - Beacon route or section name.
 */
export function navigateBeacon(location) {
  window.Beacon('navigate', location);
}
